import { render, staticRenderFns } from "./board_read.vue?vue&type=template&id=8dcc340c&scoped=true&"
import script from "./board_read.vue?vue&type=script&lang=js&"
export * from "./board_read.vue?vue&type=script&lang=js&"
import style0 from "./board_read.vue?vue&type=style&index=0&id=8dcc340c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcc340c",
  null
  
)

export default component.exports